import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _typeof from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/typeof.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
import { backgroundColorField, getBackgroundColor, getTextColor } from "../utils/PanelStyleUtils";
import { editLayoutState, isTouchInteraction, setPopupOpen } from "../utils/EditLayoutMode";
export default {
  name: "EditStyle",
  props: {
    haveBackground: {
      type: Boolean,
      default: true
    },
    // elementos que são apenas uma faixa de fundo (sem texto próprio) escondem
    // os campos de cor, tamanho e estilo do texto
    haveText: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: "center"
    },
    classRef: {
      type: String,
      default: ""
    },
    elementType: {
      type: String,
      required: true
    },
    isPrioritary: {
      type: Boolean,
      default: false
    },
    configStylePainel: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      showBtnEdit: true,
      showDialogEdit: false,
      showSizes: false,
      showFontStyle: false,
      editLayout: editLayoutState,
      requestService: new RequestService(),
      formToolEdit: {
        textColor: "",
        backgroundColor: "",
        fontSize: "",
        weightFont: ""
      },
      fontSizes: Array.from({
        length: 100
      }, function (_, i) {
        return i + 1 + "px";
      }),
      fontWeight: ["Normal", "Bold", "Bolder", "Lighter", "100", "200", "300", "400", "500", "600", "700", "800", "900"]
    };
  },
  computed: {
    isTouchInput: function isTouchInput() {
      return isTouchInteraction();
    }
  },
  watch: {
    showDialogEdit: function showDialogEdit(isOpen) {
      setPopupOpen(this._uid, isOpen);
    }
  },
  methods: {
    closeForm: function closeForm() {
      this.showBtnEdit = true;
      this.showDialogEdit = false;
    },
    toggleEdit: function toggleEdit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var elementType, element;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.editLayout.active && _this.isTouchInput)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return _this.emitEventHide();
            case 4:
              if (!(_this.$props.elementType === undefined)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              elementType = _this.$props.elementType;
              element = _this.configStylePainel[elementType];
              _this.formToolEdit.textColor = getTextColor(_this.configStylePainel, elementType, _this.isPrioritary);
              _this.formToolEdit.backgroundColor = _this.haveBackground ? getBackgroundColor(_this.configStylePainel, elementType, _this.isPrioritary) || "" : "";
              _this.formToolEdit.fontSize = element === null || element === void 0 ? void 0 : element.fontSize;
              _this.formToolEdit.weightFont = element === null || element === void 0 ? void 0 : element.styleFont;
              _this.showBtnEdit = !_this.showBtnEdit;
              _this.showDialogEdit = !_this.showDialogEdit;
              _this.positionPopup();
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    emitEventHide: function emitEventHide() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$root.$emit("hideComponent");
              return _context2.abrupt("return", new Promise(function (res) {
                setTimeout(function () {
                  res(true);
                }, 100);
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    positionPopup: function positionPopup() {
      var _this3 = this;
      this.$nextTick(function () {
        var popup = _this3.popupEl;
        if (!popup) {
          return;
        }
        var margin = 8;
        var anchorRect = _this3.$el.getBoundingClientRect();
        var popupRect = popup.getBoundingClientRect();
        var top = anchorRect.bottom;
        var left = anchorRect.left;
        if (left + popupRect.width > window.innerWidth - margin) {
          left = window.innerWidth - margin - popupRect.width;
        }
        if (left < margin) {
          left = margin;
        }
        if (top + popupRect.height > window.innerHeight - margin) {
          top = window.innerHeight - margin - popupRect.height;
        }
        if (top < margin) {
          top = margin;
        }
        popup.style.top = "".concat(top, "px");
        popup.style.left = "".concat(left, "px");
      });
    },
    toggleMenu: function toggleMenu(menu) {
      if (menu === "size") {
        this.showSizes = !this.showSizes;
        this.showFontStyle = false;
      } else if (menu === "weight") {
        this.showFontStyle = !this.showFontStyle;
        this.showSizes = false;
      }
      // .c-tools.menu-open cresce para caber a lista, entao o popup precisa
      // ser reposicionado para nao passar da borda da tela
      this.positionPopup();
    },
    selectOption: function selectOption(type, option) {
      if (type === "fontSize") {
        this.formToolEdit.fontSize = option;
      } else if (type === "fontStyle") {
        this.formToolEdit.weightFont = option;
      }
      this.showSizes = false;
      this.showFontStyle = false;
    },
    buildEditedElement: function buildEditedElement(menuEdited) {
      var current = this.configStylePainel[menuEdited];
      var element = _objectSpread({}, current && _typeof(current) === "object" ? current : {});
      if (this.haveText) {
        element.color = this.formToolEdit.textColor;
        element.fontSize = this.formToolEdit.fontSize;
        element.styleFont = this.formToolEdit.weightFont;
      }
      if (this.haveBackground && this.formToolEdit.backgroundColor !== "") {
        // a cor de fundo fica no próprio elemento, para que cada componente do
        // painel seja personalizado de forma individual
        element[backgroundColorField(menuEdited, this.isPrioritary)] = this.formToolEdit.backgroundColor;
      }
      return element;
    },
    /**
     * O cabeçalho e o corpo do painel usam cópias diferentes da configuração, e
     * cada uma pode estar desatualizada. Por isso a configuração atual é buscada
     * no servidor e apenas o elemento editado é alterado, evitando sobrescrever
     * o que já foi salvo em outro componente.
     */
    buildRequestBody: function buildRequestBody(menuEdited, editedElement) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var configAtual, _yield$_this4$request, data, bodyRequest, _i, _Object$keys, key;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              configAtual = _this4.configStylePainel;
              _context3.prev = 1;
              _context3.next = 4;
              return _this4.requestService.findPanelByChannel(_this4.$route.params.cliente, _this4.$route.params.channel);
            case 4:
              _yield$_this4$request = _context3.sent;
              data = _yield$_this4$request.data;
              if (data && data.configStylesPainel) {
                configAtual = data.configStylesPainel;
              }
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](1);
              console.info("Não foi possível recarregar a configuração atual", _context3.t0);
            case 12:
              bodyRequest = _objectSpread(_objectSpread({}, configAtual), {}, _defineProperty({}, menuEdited, editedElement));
              for (_i = 0, _Object$keys = Object.keys(bodyRequest); _i < _Object$keys.length; _i++) {
                key = _Object$keys[_i];
                if (key !== "id" && key !== "clienteId" && typeof bodyRequest[key] !== "string") {
                  bodyRequest[key] = JSON.stringify(bodyRequest[key]);
                }
              }
              return _context3.abrupt("return", bodyRequest);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 9]]);
      }))();
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var menuEdited, editedElement, bodyRequest;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              menuEdited = _this5.$props.elementType;
              editedElement = _this5.buildEditedElement(menuEdited);
              _this5.$set(_this5.configStylePainel, menuEdited, editedElement);
              if (!(_this5.configStylePainel.id == "config-style")) {
                _context4.next = 6;
                break;
              }
              _this5.closeForm();
              return _context4.abrupt("return");
            case 6:
              _context4.prev = 6;
              _context4.next = 9;
              return _this5.buildRequestBody(menuEdited, editedElement);
            case 9:
              bodyRequest = _context4.sent;
              _context4.next = 12;
              return _this5.requestService.saveConfigStyle(bodyRequest, _this5.$route.params.cliente);
            case 12:
              _this5.$root.$emit("updatePainelStyle");
              _context4.next = 19;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](6);
              alert("Erro ao salvar");
              console.info(_context4.t0);
            case 19:
              _this5.closeForm();
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[6, 15]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this6 = this;
    this.$root.$on("hideComponent", function () {
      _this6.showBtnEdit = true;
      _this6.showDialogEdit = false;
    });
    this.$root.$emit("updatePainelStyleMainLayout");
    this.onReposition = function () {
      if (_this6.showDialogEdit) {
        _this6.positionPopup();
      }
    };
    window.addEventListener("resize", this.onReposition);
    window.addEventListener("orientationchange", this.onReposition);
    window.addEventListener("scroll", this.onReposition, true);

    // The popup is moved to <body> exactly once, here, instead of on every
    // open/close. It uses v-show (not v-if) so Vue never has to insert or
    // remove this node relative to .c-main again — repeating the move on
    // every toggle let a re-render of .c-main (e.g. from a live data
    // refresh) race with the node sitting outside its expected DOM
    // position, leaving showDialogEdit true with no popup actually in the
    // document.
    this.$nextTick(function () {
      var popup = _this6.$el.querySelector(".main-popup");
      if (popup) {
        _this6.popupEl = popup;
        document.body.appendChild(popup);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    setPopupOpen(this._uid, false);
    if (this.popupEl && this.popupEl.parentNode) {
      this.popupEl.parentNode.removeChild(this.popupEl);
    }
    window.removeEventListener("resize", this.onReposition);
    window.removeEventListener("orientationchange", this.onReposition);
    window.removeEventListener("scroll", this.onReposition, true);
  }
};